export const createCSVString = (rows, columns) => {
  const headers = columns.map(c => c.Header);
  const accessors = columns.map(c => c.accessor);

  const lines = [];
  lines.push(headers.map(csvCell).join(',')); // header row

  for (const r of rows) {
    lines.push(
      accessors
        .map(a => csvCell(a ? r[a] : '')) // only the columns we want, in order
        .join(',')
    );
  }
  return lines.join('\n');
};

export const csvCell = v => {
  if (v === null || v === undefined) return '';
  const s = String(v).replace(/"/g, '""'); // escape quotes
  return /[",\n]/.test(s) ? `"${s}"` : s; // wrap if needed
};

export const getFromLocalStorage = keysArray => {
  const result = keysArray.reduce((acc, key) => {
    let rawValue = localStorage.getItem(key);
    acc[key] =
      (rawValue && rawValue !== 'undefined' && JSON.parse(rawValue)) ||
      undefined;
    return acc;
  }, {});
  return result;
};

export const addToLocalStorage = dataArray => {
  dataArray.forEach(obj =>
    localStorage.setItem(obj.name, JSON.stringify(obj.data))
  );
};

export const getMakePaymentVaultCompany = outstandingBillings => {
  let isCaAdmin = false;
  let locationsArray = [];
  let businessName = '';

  let { userDetailDict } = getFromLocalStorage(['userDetailDict']);

  if (userDetailDict) {
    isCaAdmin = userDetailDict.caAdmin && userDetailDict.caAdmin === '1';
    locationsArray = userDetailDict.locations || [];
    businessName = userDetailDict.businessname;
  }

  // caAdmin should not be associated with loc_shortname
  if (!isCaAdmin) {
    let testLocationId =
      outstandingBillings[0] && outstandingBillings[0].locationId;
    // Add loc_shortname only if all invoices correspond to one particular location
    const isOneLocation = outstandingBillings.every(
      billing => billing.locationId && billing.locationId === testLocationId
    );
    if (isOneLocation) {
      let locationObj = locationsArray.find(
        location => location.ntwkid === testLocationId
      );
      if (locationObj && locationObj.loc_shortName) {
        return `${locationObj.loc_shortName} - ${businessName}`;
      }
    }
  }

  return businessName;
};

export const getChangeBillingMethodVaultCompany = subscription => {
  let isCaAdmin = false;
  let locationsArray = [];
  let businessName = '';

  let { userDetailDict } = getFromLocalStorage(['userDetailDict']);

  if (userDetailDict) {
    isCaAdmin = userDetailDict.caAdmin && userDetailDict.caAdmin === '1';
    locationsArray = userDetailDict.locations || [];
    businessName = userDetailDict.businessname;
  }

  if (subscription && !isCaAdmin) {
    let locationId =
      subscription?.location?.id || subscription.locationOrPartnerId;

    // caAdmin should not be associated with loc_shortname
    if (!isCaAdmin && locationId && locationId !== '') {
      let locationObj = locationsArray.find(
        location => location.ntwkid === locationId
      );
      if (locationObj && locationObj.loc_shortName) {
        return `${locationObj.loc_shortName} - ${businessName}`;
      }
    }
  } else if (!isCaAdmin && locationsArray?.length === 1) {
    let locationObj = locationsArray[0];
    if (locationObj?.loc_shortName) {
      return `${locationObj.loc_shortName} - ${businessName}`;
    }
  }

  return businessName;
};

export const generatePhpAuthParams = () => {
  const { userDetailDict } = getFromLocalStorage(['userDetailDict']);

  const {
    token: Turtle,
    partnerID: pantherIndy,
    userid: unicornIndy,
    locations,
  } = userDetailDict ?? {};

  const ntwkids = locations.reduce(
    (acc, location) => [...acc, location.ntwkid],
    []
  );

  return {
    Turtle,
    newtIndys: JSON.stringify(ntwkids),
    pantherIndy,
    unicornIndy,
  };
};

export const formatDateFromIsoString = (dateIsoString, dateOnly = false) => {
  const date = new Date(dateIsoString);
  return dateOnly ? date.toLocaleDateString() : date.toLocaleString();
};
